import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/x-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/x" });
	},
});
